<div class="qo-card">
	<div
		class="border qo-flex-col-top-left"
		*ngFor="let sickDay of sickDays"
	>
		<div class="qo-padding30 qo-flex-row-space-between padding-mobile">
			<div class="qo-flex-row-top-left qo-position-relative">
				<qo-profile-image
					[imageUrl]="sickDay.shift.user.profile_picture?.download_url"
					[letter]="sickDay.shift.user.getInitials()"
					[size]="50"
					[fontSize]="20"
				></qo-profile-image>
				<div class="qo-flex-col-top-left qo-margin-left20">
					<h3>
						{{sickDay.shift.user.getFullName()}}
					</h3>
					<div class="text-grey">
						{{sickDay.shift.start.format("DD/MM/YYYY")}}
					</div>
					<div class="text-grey">
						{{sickDay.shift.start.localDate.format('HH:mm') }} - {{sickDay.shift.end.localDate.format('HH:mm')}}
					</div>
				</div>
			</div>
			<div
				class="qo-flex-col-top-left align-center"
				*ngIf="authService.windowWidth >= SCREEN.S"
			>
				<h4>
					{{'ACTIONS.NOTE' | translate}}
				</h4>
				<div class="text-grey qo-margin-top10">
					“ {{sickDay.message}} ”
				</div>
			</div>
			<div class="qo-flex-row-top-right"
					 *ngIf="(user$ | async) as user"
			>
				<div>
					<h4
						*ngIf="(user$ | async)?.permission_level === 2"
					>
						{{sickDay.sick_message_responses_count}} {{sickDay.sick_message_responses_count | i18nPlural: {
						'=1': 'SICK_DAY.ANSWER_SINGLE',
						'other': 'SICK_DAY.ANSWERS_MULTI'
					} | translate}}
					</h4>
					<div [ngClass]="user.permission_level === 2 ? 'qo-flex-row-top-left' : 'qo-flex-row-top-right'">
						<button
							class="qo-button-small qo-margin-top10"
							[ngClass]="user.permission_level === 2 ? 'qo-white' : 'qo-primary'"
							(click)="user.permission_level === 2 ? viewAnswers(sickDay): answer(sickDay)"
						>
							{{user.permission_level === 2 ? ('SICK_DAY.VIEW_ANSWERS' | translate) : 'SICK_DAY.ANSWER' | translate}}
						</button>
					</div>
				</div>
				<qo-icon
					*ngIf="(user$ | async).permission_level === 2"
					[class.qo-margin-left30]="authService.windowWidth > SCREEN.S"
					[icon]="EQORebrandIcon.trash_dark"
					[invertedScheme]="true"
					[scheme]="EQORebrandColor.SECONDARY"
					[color]="EQORebrandColor.SECONDARY"
					[size]="'sm'"
					(click)="deleteSickDay(sickDay)"
				></qo-icon>
			</div>
		</div>
	</div>
</div>
